"use client";

import { Github, Linkedin, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function Footer() {
  const socials = [{
    name: "X",
    icon: Twitter,
    href: "#"
  }, {
    name: "LinkedIn",
    icon: Linkedin,
    href: "#"
  }, {
    name: "GitHub",
    icon: Github,
    href: "#"
  }, {
    name: "YouTube",
    icon: Youtube,
    href: "#"
  }];
  const platformLinks = [{
    label: "Produtos",
    href: "/ProductsPage"
  }, {
    label: "Aplicações",
    href: "/ApplicationsPage"
  }, {
    label: "Biblioteca",
    href: "/LibraryPage"
  }, {
    label: "Engenharia",
    href: "/ProductsPage"
  }, {
    label: "Inovação",
    href: "/SustainabilityPage"
  }];
  const companyLinks = [{
    label: "Início",
    href: "/HomePage"
  }, {
    label: "Sobre nós",
    href: "/HomePage"
  }, {
    label: "Parceiros",
    href: "/HomePage"
  }, {
    label: "Contactos",
    href: "/ContactsPage"
  }];
  const resourceLinks = [{
    label: "Catálogos",
    href: "/LibraryPage"
  }, {
    label: "Manuais",
    href: "/LibraryPage"
  }, {
    label: "Casos",
    href: "/ApplicationsPage"
  }, {
    label: "Suporte",
    href: "/ContactsPage"
  }];
  const legalLinks = [{
    label: "Privacidade",
    href: "/PrivacyPolicyPage"
  }, {
    label: "Termos",
    href: "/TermsAndConditionsPage"
  }, {
    label: "Ética",
    href: "/EthicsPage"
  }, {
    label: "Segurança",
    href: "/SecurityPage"
  }];
  const bottomLegal = [{
    label: "Privacidade",
    href: "/PrivacyPolicyPage"
  }, {
    label: "Termos",
    href: "/TermsAndConditionsPage"
  }, {
    label: "Ética",
    href: "/EthicsPage"
  }];
  const linkColumns = [{
    eyebrow: "Soluções",
    items: platformLinks
  }, {
    eyebrow: "Empresa",
    items: companyLinks
  }, {
    eyebrow: "Recursos",
    items: resourceLinks
  }, {
    eyebrow: "Legal",
    items: legalLinks
  }];
  return <section data-section-id="31361" id="rodapé-institucional" data-nav="dark" className="bg-primary text-primary-foreground py-32 md:py-40">
      <div className="mx-auto max-w-[1360px] px-6 md:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
          {}
          <div className="md:col-span-4">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto text-primary-foreground" />
            </Link>
            <p className="mt-6 text-base leading-relaxed text-primary-foreground/80 max-w-sm">Eurocontrol Lda<br />Estrada de São Marcos, ELOS PARK II, ELO B10&nbsp;<br />2735-521 Agualva-Cacém<br />Telefone: 21 426 7830<br />Email: eurocontrol@eurocontrol.pt<br /><br /><br /><br /><br /><br /><br /><br /><br /></p>
            <div className="mt-8 flex items-center gap-5">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.name} data-index={i} to={social.href} aria-label={social.name} className="text-primary-foreground/60 transition-colors duration-200 hover:text-primary-foreground">
                    <Icon className="h-5 w-5" strokeWidth={1.25} />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="md:col-span-8 grid grid-cols-2 gap-8 sm:grid-cols-4 md:grid-cols-4">
            {linkColumns.map((col, i) => <div key={col.eyebrow} data-index={i}>
                <h3 className="font-default text-xs font-medium uppercase tracking-[0.22em] text-primary-foreground/60">
                  {col.eyebrow}
                </h3>
                <ul className="mt-6 space-y-3">
                  {col.items.map((item, j) => <li key={item.label} data-index={j}>
                      <Link to={item.href} className="group inline-flex items-center text-sm text-primary-foreground transition-all duration-200 hover:text-secondary hover:translate-x-1">
                        {item.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-20 h-px w-full bg-primary-foreground/20" />

        {}
        <div className="mt-8 flex flex-col-reverse items-start gap-4 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-primary-foreground/60">© 2026 Eurocontrol. Todos os direitos reservados.<div data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:cz87ky" data-ast-start="4358" data-ast-end="4537">O conteúdo deste website, incluindo textos, imagens, estrutura e design, é protegido por direitos de autor. Qualquer reprodução ou utilização não autorizada é proibida.</div></p>
          <div className="flex flex-wrap items-center gap-6">
            {bottomLegal.map((item, i) => <Link key={item.label} data-index={i} to={item.href} className="text-sm text-primary-foreground/60 transition-colors duration-200 hover:text-primary-foreground">
                {item.label}
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}